module.exports = __webpack_public_path__ + "img/Deathknight-nightelf-f-70.0dfbb004.gif";